export default {
  events: {
    buyWithDelivery: 'delivery_click',
    askForDelivery: 'delivery_buyer_ask_for_delivery',
    addDelivery: 'delivery_seller_enable_delivery',
    cancelOrder: 'delivery_seller_cancel_order',
    cancelOrderConfirmation: 'delivery_seller_cancel_order_conf',
    cancelOrderResignation: 'delivery_seller_cancel_order_resignation',
    ordersAcceptDeal: 'delivery_orders_accept_deal',
    ordersRejectDeal: 'delivery_order_details_reject_deal',
    ordersRejectionConfirm: 'delivery_order_details_rejection_confirm',
    ordersRejectionCancel: 'delivery_order_details_rejection_cancel',
    deliveryOrdersRejectDeal: 'delivery_orders_reject_deal',
    deliveryOrdersRejectionConfirm: 'delivery_orders_rejection_confirm',
    deliveryOrdersRejectionCancel: 'delivery_orders_rejection_cancel',
    deliveryOrdersBuyer: 'delivery_orders_buyer',
    deliveryOrderDetailsBuyerSupport: 'delivery_order_details_buyer_support',
    deliveryOrdersAdClick: 'delivery_orders_ad_click',
    pageView: 'page_view',
    // safe deal happy path - order acceptance
    deliverySafeDealAcceptClick: 'delivery_sd_accept_click',
    deliverySafeDealAcceptConfirmShow: 'delivery_sd_accept_confirm_show',
    deliverySafeDealAcceptConfirmClick: 'delivery_sd_accept_confirm_click',
    deliverySafeDealAcceptReturnClick: 'delivery_sd_accept_return_click',
    deliverySafeDealAcceptSuccessShow: 'delivery_sd_accept_success_show',
    deliverySafeDealAcceptGoToMydelivClick: 'delivery_sd_accept_goto_mydeliv_click',
    // safe deal unhappy path - order rejection
    deliverySafeDealReportClick: 'delivery_sd_report_click',
    deliverySafeDealReportConfirmShow: 'delivery_sd_report_confirm_show',
    deliverySafeDealReportConfirmClick: 'delivery_sd_report_confirm_click',
    deliverySafeDealReportReturnClick: 'delivery_sd_report_return_click',
    // safe deal report form
    deliverySafeDealReportFormInfoOkClick: 'delivery_sd_report_info_ok_click',
    deliverySafeDealReportFormDescrClick: 'delivery_sd_report_descr_click',
    deliverySafeDealReportFormDescrFilled: 'delivery_sd_report_descr_filled',
    deliverySafeDealReportFormPhotoClick: 'delivery_sd_report_photo_click',
    deliverySafeDealReportFormPhotoFilled: 'delivery_sd_report_photo_filled',
    deliverySafeDealReportFormSubmitClick: 'delivery_sd_report_submit_click',
    deliverySafeDealReportFormSuccessShow: 'delivery_sd_report_success_show',
    deliverySafeDealReportFormGoToMyDelivClick: 'delivery_sd_report_goto_mydeliv_click',
    deliverySafeDealReportFormCancelClick: 'delivery_sd_report_cancel_click',
    deliverySellerStatsDisplayed: 'delivery_seller_stats_displayed',
    deliverySafeDealReportSuccessChatButtonClick: 'reply_chat_click',
    deliverySafeDealReportSuccessChatButtonShown: 'sd_chat_btn_visible',
    // safe deal - general
    deliverySafeDealHowItWorksClick: 'delivery_sd_how_it_works_click',
    deliverySafeDealBuyerActionPageView: 'delivery_sd_buyer_action_page_view',
    // safe deal - ad page
    safeDealInfoIconClick: 'safedeal_info_icon_click',
    safeDealInfoboxCloseClick: 'safedeal_infobox_close_click',
    safeDealTermsAndConditionClick: 'sd_terms_and_conditions_click',
    safeDealInfoboxOpened: 'sd_infobox_opened',
    // safe deal - returns
    deliverySdReportReadClick: 'delivery_sd_report_read',
    deliverySdHowItWorksClick: 'delivery_sd_how_it_works_click',
  },
  touchPointPages: {
    myDeliveries: 'my_deliveries',
    returnOverview: 'delivery_return_overview',
    returnDetails: 'delivery_return_details',
    returnError: 'delivery_return_error',
    deliverySdOverview: 'delivery_sd_overview',
  },
} as const;
